import { render, staticRenderFns } from "./tablaNiveles.vue?vue&type=template&id=d2823b76&scoped=true&"
import script from "./tablaNiveles.vue?vue&type=script&lang=js&"
export * from "./tablaNiveles.vue?vue&type=script&lang=js&"
import style0 from "./tablaNiveles.vue?vue&type=style&index=0&id=d2823b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2823b76",
  null
  
)

export default component.exports